export default __webpack_public_path__ + "static/media/nintendo.8a981979.svg";